<template>
    <PopupRouterView :showLeftIcon="true" label="Subcontract Good Receipt Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="subcontractgoodreceipt"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="subcontractGoodReceiptInput">


        <b-card header="Subcontract Good Receipt" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-label label-cols-lg="12" size="sm" type="generatednumber" label="Subcontract Good Receipt Number" :model="model.subcontractGoodReceiptNumber" />
						<app-input-combobox-autocomplete :options="subcontractRequestDeliverys" optionsLabel="requestDeliveryNumber" optionsKey="id" label-cols-lg="12" label="Subcontract Request Delivery Number" id="fieldset-subcontract-request-delivery" size="sm" :model.sync="model.subcontractRequestDeliveryId"   :selected="model.subcontractRequestDelivery != null ? model.subcontractRequestDelivery.requestDeliveryNumber : ''" @input="getSubcontractRequestDeliverys" @change="updateData" :isUpdatable ="null" :isSelectMethodExists="true" @onSelectMethod="setSelectedSubcontractRequestDelivery" />
						<app-input-combobox-autocomplete :options="documentStatuss" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Document Status" id="fieldset-document-status" size="sm" :model.sync="model.documentStatusId"   :selected="model.documentStatus != null ? model.documentStatus.name : ''" @input="getDocumentStatuss" @change="updateData" :isUpdatable ="null" :isSelectMethodExists="true" @onSelectMethod="setSelectedDocumentStatus" />
						<app-input-textbox id="fieldset-surat-jalan" label-cols-lg="12"  label="Surat Jalan" label-for="input-surat-jalan" size="sm" :model.sync="model.suratJalan"  @change="updateData" :isUpdatable ="null"/>
						<app-input-textarea id="fieldset-remarks" label-cols-lg="12"  label="Remarks" label-for="input-remarks" size="sm" :model.sync="model.remarks"  @change="updateData" :isUpdatable ="null"/>
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>

		<app-table-input 
			title = "Subcontract GR Control Card"
			:bordered="true" :items="subcontractGoodReceiptDetails" 
			:fields="fieldsSubcontractGoodReceiptDetail" 
			:busy="isDataLoading" 
			:sort-by.sync="sortBySubcontractGoodReceiptDetail" 
			:sort-desc.sync="sortDescSubcontractGoodReceiptDetail" small responsive	
			@editButtonMethod="editRowDataSubcontractGoodReceiptDetail"	
			@deleteButtonMethod="deleteRowDataSubcontractGoodReceiptDetail"	
			@showPopupAddMethod="addDataSubcontractGoodReceiptDetail()"	
			@showPopupUploadMethod="showPopupUploadSubcontractGoodReceiptDetail()"
			@downloadMethod="downloadSubcontractGoodReceiptDetail()"
			@addFromClipboardMethod="addFromClipboardSubcontractGoodReceiptDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardSubcontractGoodReceiptDetail()"
			:showActionButton="true"
			:showDeleteButton="true"
			:showAddButton="true"
			:showAddFromClipboardButton="false"	
			:showReplaceFromClipboardButton="false"	
			:showUploadButton="true"	
			:showDownloadButton="true"	
			:isDownloadBusy="isDownloadSubcontractGoodReceiptDetail"
		>
								
			<!-- <template v-slot:head(actions)>
				<b-button @click="isShowSubcontractGoodReceiptDetailFilter = !isShowSubcontractGoodReceiptDetailFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
			</template> -->
								
			<template #top-row v-if="isShowSubcontractGoodReceiptDetailFilter">
				<b-th></b-th>
				<b-th stacked-heading="Control Card">
					<v-select id="input-subcontract-good-receipt-detail-control-card-table" append-to-body label="controlCardNumber" :options="controlCards" :value="filterSubcontractGoodReceiptDetail.controlCardId" :reduce="item => item.id" v-model="filterSubcontractGoodReceiptDetail.controlCardId" @search="getControlCards" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Is Complete">
					<b-form-checkbox id="input-subcontract-good-receipt-detail-is-complete-table" class="float-right" v-model="filterSubcontractGoodReceiptDetail.isComplete"></b-form-checkbox>
				</b-th>
				<b-th stacked-heading="Case Qty">
					<b-form-input id="input-subcontract-good-receipt-detail-case-qty-table" v-model="filterSubcontractGoodReceiptDetail.caseQty" size="sm"></b-form-input>
				</b-th>

				<b-th></b-th>
			</template>
								
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( subcontractGoodReceiptDetailPageSize * (currentSubcontractGoodReceiptDetailPage - 1))) }}
			</template>
								
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
								
			<template v-slot:cell(controlCard)="row">
				<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" :id="'input-subcontract-good-receipt-detail-control-card-' + row.index" label-cols-lg="12" label="Control Card" size="sm" :model.sync="row.item.controlCardId"  @change="saveInputSubcontractGoodReceiptDetail(row.item)" :selected="row.item.controlCard != null ? row.item.controlCard.controlCardNumber : ''"  @input="getControlCards" :loading="isControlCardComboLoading"  :isUpdatable ="null"  :nolabel="true" />
			</template>
			<template v-slot:cell(isComplete)="row">
				<app-input-checkbox :id="'input-subcontract-good-receipt-detail-is-complete-row-' + row.index" label-cols-lg="12" label="Is Complete" :model.sync="row.item.isComplete" @change="saveInputSubcontractGoodReceiptDetail(row.item)" :isUpdatable ="null"  :nolabel="true"></app-input-checkbox>
			</template>
			<template v-slot:cell(caseQty)="row">
				<app-input-textbox :id="'input-subcontract-good-receipt-detail-case-qty-' + row.index" label-cols-lg="12" label="Case Qty" size="sm" :model.sync="row.item.caseQty"   @change="saveInputSubcontractGoodReceiptDetail(row.item)" :isUpdatable ="null"  :nolabel="true" />
			</template>

								
			<template v-slot:form-add-detail>
				<SubcontractGoodReceiptDetailInput 
					:model="modelSubcontractGoodReceiptDetail"
					:openPopup="isShowPopupSubcontractGoodReceiptDetail"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataSubcontractGoodReceiptDetail"/>
			</template>
			<template v-slot:upload-detail>
					<SubcontractGoodReceiptDetailUpload
					:openPopup="isShowPopupUploadSubcontractGoodReceiptDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataSubcontractGoodReceiptDetail"
					:parentId="modelId"
					/>
			</template>
			<!-- <template v-slot:table-paging>
				<b-pagination
				class="float-right btn-paging"
				v-model="currentSubcontractGoodReceiptDetailPage"
				:total-rows="totalSubcontractGoodReceiptDetailRow"
				:per-page="subcontractGoodReceiptDetailPageSize"
				aria-controls="my-table"
				></b-pagination>
			</template> -->
		</app-table-input>
		<app-table-input 
			title = "Suggestion Control Card"
			:bordered="true" :items="subcontractGoodReceiptSuggestionDetails" 
			:fields="fieldsSubcontractGoodReceiptSuggestionDetail" 
			:busy="isDataLoading" 
			:sort-by.sync="sortBySubcontractGoodReceiptSuggestionDetail" 
			:sort-desc.sync="sortDescSubcontractGoodReceiptSuggestionDetail" small responsive	
			@editButtonMethod="editRowDataSubcontractGoodReceiptSuggestionDetail"	
			@deleteButtonMethod="deleteRowDataSubcontractGoodReceiptSuggestionDetail"	
			@showPopupAddMethod="addDataSubcontractGoodReceiptSuggestionDetail()"	
			@showPopupUploadMethod="showPopupUploadSubcontractGoodReceiptSuggestionDetail()"
			@downloadMethod="downloadSubcontractGoodReceiptSuggestionDetail()"
			@addFromClipboardMethod="addFromClipboardSubcontractGoodReceiptSuggestionDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardSubcontractGoodReceiptSuggestionDetail()"
			:showActionButton="true"
			:showDeleteButton="true"
			:showAddButton="true"
			:showAddFromClipboardButton="false"	
			:showReplaceFromClipboardButton="false"	
			:showUploadButton="true"	
			:showDownloadButton="true"	
			:isDownloadBusy="isDownloadSubcontractGoodReceiptSuggestionDetail"
		>
								
			<!-- <template v-slot:head(actions)>
				<b-button @click="isShowSubcontractGoodReceiptSuggestionDetailFilter = !isShowSubcontractGoodReceiptSuggestionDetailFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
			</template> -->
								
			<template #top-row v-if="isShowSubcontractGoodReceiptSuggestionDetailFilter">
				<b-th></b-th>
				<b-th stacked-heading="Control Card">
					<v-select id="input-subcontract-good-receipt-suggestion-detail-control-card-table" append-to-body label="controlCardNumber" :options="controlCards" :value="filterSubcontractGoodReceiptSuggestionDetail.controlCardId" :reduce="item => item.id" v-model="filterSubcontractGoodReceiptSuggestionDetail.controlCardId" @search="getControlCards" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Case Qty">
					<b-form-input id="input-subcontract-good-receipt-suggestion-detail-case-qty-table" v-model="filterSubcontractGoodReceiptSuggestionDetail.caseQty" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Used Qty">
					<b-form-input id="input-subcontract-good-receipt-suggestion-detail-used-qty-table" v-model="filterSubcontractGoodReceiptSuggestionDetail.usedQty" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Is Scanned">
					<b-form-checkbox id="input-subcontract-good-receipt-suggestion-detail-is-scanned-table" class="float-right" v-model="filterSubcontractGoodReceiptSuggestionDetail.isScanned"></b-form-checkbox>
				</b-th>

				<b-th></b-th>
			</template>
								
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( subcontractGoodReceiptSuggestionDetailPageSize * (currentSubcontractGoodReceiptSuggestionDetailPage - 1))) }}
			</template>
								
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
								
			<template v-slot:cell(controlCard)="row">
				<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" :id="'input-subcontract-good-receipt-suggestion-detail-control-card-' + row.index" label-cols-lg="12" label="Control Card" size="sm" :model.sync="row.item.controlCardId"  @change="saveInputSubcontractGoodReceiptSuggestionDetail(row.item)" :selected="row.item.controlCard != null ? row.item.controlCard.controlCardNumber : ''"  @input="getControlCards" :loading="isControlCardComboLoading"  :isUpdatable ="null"  :nolabel="true" />
			</template>
			<template v-slot:cell(caseQty)="row">
				<app-input-textbox :id="'input-subcontract-good-receipt-suggestion-detail-case-qty-' + row.index" label-cols-lg="12" label="Case Qty" size="sm" :model.sync="row.item.caseQty"   @change="saveInputSubcontractGoodReceiptSuggestionDetail(row.item)" :isUpdatable ="null"  :nolabel="true" />
			</template>
			<template v-slot:cell(usedQty)="row">
				<app-input-textbox :id="'input-subcontract-good-receipt-suggestion-detail-used-qty-' + row.index" label-cols-lg="12" label="Used Qty" size="sm" :model.sync="row.item.usedQty"   @change="saveInputSubcontractGoodReceiptSuggestionDetail(row.item)" :isUpdatable ="null"  :nolabel="true" />
			</template>
			<template v-slot:cell(isScanned)="row">
				<app-input-checkbox :id="'input-subcontract-good-receipt-suggestion-detail-is-scanned-row-' + row.index" label-cols-lg="12" label="Is Scanned" :model.sync="row.item.isScanned" @change="saveInputSubcontractGoodReceiptSuggestionDetail(row.item)" :isUpdatable ="null"  :nolabel="true"></app-input-checkbox>
			</template>

								
			<template v-slot:form-add-detail>
				<SubcontractGoodReceiptSuggestionDetailInput 
					:model="modelSubcontractGoodReceiptSuggestionDetail"
					:openPopup="isShowPopupSubcontractGoodReceiptSuggestionDetail"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataSubcontractGoodReceiptSuggestionDetail"/>
			</template>
			<template v-slot:upload-detail>
					<SubcontractGoodReceiptSuggestionDetailUpload
					:openPopup="isShowPopupUploadSubcontractGoodReceiptSuggestionDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataSubcontractGoodReceiptSuggestionDetail"
					:parentId="modelId"
					/>
			</template>
			<!-- <template v-slot:table-paging>
				<b-pagination
				class="float-right btn-paging"
				v-model="currentSubcontractGoodReceiptSuggestionDetailPage"
				:total-rows="totalSubcontractGoodReceiptSuggestionDetailRow"
				:per-page="subcontractGoodReceiptSuggestionDetailPageSize"
				aria-controls="my-table"
				></b-pagination>
			</template> -->
		</app-table-input>


        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import SubcontractGoodReceipt from '@/models/SubcontractGoodReceipt/SubcontractGoodReceipt';
import SubcontractGoodReceiptList from '@/models/SubcontractGoodReceipt/SubcontractGoodReceiptList';
import SubcontractGoodReceiptFilter from '@/filters/SubcontractGoodReceipt/SubcontractGoodReceiptFilter';

import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import SubcontractRequestDelivery from '@/models/SubcontractRequestDelivery/SubcontractRequestDelivery';
import SubcontractRequestDeliveryFilter from '@/filters/SubcontractRequestDelivery/SubcontractRequestDeliveryFilter';
import DocumentStatus from '@/models/DocumentStatus/DocumentStatus';
import DocumentStatusFilter from '@/filters/DocumentStatus/DocumentStatusFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputTextarea from '@/components/AppInputTextarea';
import SubcontractGoodReceiptDetail from '@/models/SubcontractGoodReceipt/SubcontractGoodReceiptDetail';
import SubcontractGoodReceiptDetailFilter from '@/filters/SubcontractGoodReceipt/SubcontractGoodReceiptDetailFilter';
import SubcontractGoodReceiptSuggestionDetail from '@/models/SubcontractGoodReceipt/SubcontractGoodReceiptSuggestionDetail';
import SubcontractGoodReceiptSuggestionDetailFilter from '@/filters/SubcontractGoodReceipt/SubcontractGoodReceiptSuggestionDetailFilter';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import AppInputCheckbox from '@/components/AppInputCheckbox';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import SubcontractGoodReceiptDetailInput from '@/views/SubcontractGoodReceipt/SubcontractGoodReceiptDetailInput';
import SubcontractGoodReceiptDetailUpload from '@/views/SubcontractGoodReceipt/SubcontractGoodReceiptDetailUpload';
import SubcontractGoodReceiptSuggestionDetailInput from '@/views/SubcontractGoodReceipt/SubcontractGoodReceiptSuggestionDetailInput';
import SubcontractGoodReceiptSuggestionDetailUpload from '@/views/SubcontractGoodReceipt/SubcontractGoodReceiptSuggestionDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppLabel,
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		AppInputTextarea,
		AppInputCheckbox,
		SubcontractGoodReceiptDetailInput,SubcontractGoodReceiptDetailUpload,
		SubcontractGoodReceiptSuggestionDetailInput,SubcontractGoodReceiptSuggestionDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsSubcontractGoodReceiptDetail: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"controlCard": { "class" : "th-control-card first-child", "label" : "Control Card", key: 'controlCard', sortable: false}}, 
				{"isComplete": { "class" : "th-is-complete", "label" : "Is Complete", key: 'isComplete', sortable: false}}, 
				{"caseQty": { "class" : "th-case-qty last-child", "label" : "Case Qty", key: 'caseQty', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			fieldsSubcontractGoodReceiptSuggestionDetail: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"controlCard": { "class" : "th-control-card first-child", "label" : "Control Card", key: 'controlCard', sortable: false}}, 
				{"caseQty": { "class" : "th-case-qty", "label" : "Case Qty", key: 'caseQty', sortable: false}}, 
				{"usedQty": { "class" : "th-used-qty last-child", "label" : "Used Qty", key: 'usedQty', sortable: false}}, 
				{"isScanned": { "class" : "th-is-scanned d-stack-none", "label" : "Is Scanned", key: 'isScanned', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelSubcontractGoodReceiptDetail : {},
			isShowPopupSubcontractGoodReceiptDetail : false,
			isShowPopupUploadSubcontractGoodReceiptDetail : false,
			modelSubcontractGoodReceiptSuggestionDetail : {},
			isShowPopupSubcontractGoodReceiptSuggestionDetail : false,
			isShowPopupUploadSubcontractGoodReceiptSuggestionDetail : false,
			filterSubcontractGoodReceipt : null,
			currentSubcontractGoodReceiptPage : 1,
			subcontractGoodReceiptPageSize: 10,
			sortBySubcontractGoodReceipt: '',
			sortDescSubcontractGoodReceipt: '',
			filterSubcontractGoodReceiptDetail : null,
			currentSubcontractGoodReceiptDetailPage : 1,
			subcontractGoodReceiptDetailPageSize: 10,
			sortBySubcontractGoodReceiptDetail: '',
			sortDescSubcontractGoodReceiptDetail: '',
			sortingBySubcontractGoodReceiptDetail: [],
			subcontractGoodReceiptDetails : [],
			subcontractGoodReceiptDetailId : '',
			totalSubcontractGoodReceiptDetailRow : 0,
			isShowSubcontractGoodReceiptDetailFilter: false,
			isDownloadSubcontractGoodReceiptDetail: false,
			filterSubcontractGoodReceiptSuggestionDetail : null,
			currentSubcontractGoodReceiptSuggestionDetailPage : 1,
			subcontractGoodReceiptSuggestionDetailPageSize: 10,
			sortBySubcontractGoodReceiptSuggestionDetail: '',
			sortDescSubcontractGoodReceiptSuggestionDetail: '',
			sortingBySubcontractGoodReceiptSuggestionDetail: [],
			subcontractGoodReceiptSuggestionDetails : [],
			subcontractGoodReceiptSuggestionDetailId : '',
			totalSubcontractGoodReceiptSuggestionDetailRow : 0,
			isShowSubcontractGoodReceiptSuggestionDetailFilter: false,
			isDownloadSubcontractGoodReceiptSuggestionDetail: false,
			controlCards: [],
			subcontractRequestDeliverys: [],
			subcontractRequestDeliverys: [],
			isSubcontractRequestDeliveryComboLoading: false,
			documentStatuss: [],
			documentStatuss: [],
			isDocumentStatusComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isSubcontractRequestDeliveryComboLoading: false,
			isDocumentStatusComboLoading: false,
			isSubcontractGoodReceiptComboLoading: false,
			isControlCardComboLoading: false,
			isSubcontractGoodReceiptDetailComboLoading: false,
		}
	},
	methods : {
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		getSubcontractGoodReceipt : async function(id) {
			this.isBusy = true;
			SubcontractGoodReceipt.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadSubcontractGoodReceipt = true;
			this.filterSubcontractGoodReceipt.id = this.modelId;
			SubcontractGoodReceipt.downloadDataDetail(this, this.filterSubcontractGoodReceipt).then(result => {
				this.isDownloadSubcontractGoodReceipt = false;
			}).catch(error => { this.isDownloadSubcontractGoodReceipt = false; })
		},
		getSubcontractGoodReceiptDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterSubcontractGoodReceiptDetail);
			if (this.modelId == null) return;
			filter.subcontractGoodReceiptId = this.modelId;
			filter.draftMode = "1";
			if (this.sortBySubcontractGoodReceiptDetail != null) {
				this.sortingBySubcontractGoodReceiptDetail[this.sortBySubcontractGoodReceiptDetail] = this.sortDescSubcontractGoodReceiptDetail;
			}
			let currentPage = (this.currentSubcontractGoodReceiptDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalSubcontractGoodReceiptDetailRow + 1;
				let page = Math.ceil(totalData/this.subcontractGoodReceiptDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.subcontractGoodReceiptDetailPageSize = 0;
			// disable paging end
			SubcontractGoodReceiptDetail.getList(this, filter, this.sortingBySubcontractGoodReceiptDetail, currentPage , this.subcontractGoodReceiptDetailPageSize).then(result => {
				this.currentSubcontractGoodReceiptDetailPage = currentPage + 1;
				this.subcontractGoodReceiptDetails = result.data;
				this.totalSubcontractGoodReceiptDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getSubcontractGoodReceiptSuggestionDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterSubcontractGoodReceiptSuggestionDetail);
			if (this.modelId == null) return;
			filter.subcontractGoodReceiptId = this.modelId;
			filter.draftMode = "1";
			if (this.sortBySubcontractGoodReceiptSuggestionDetail != null) {
				this.sortingBySubcontractGoodReceiptSuggestionDetail[this.sortBySubcontractGoodReceiptSuggestionDetail] = this.sortDescSubcontractGoodReceiptSuggestionDetail;
			}
			let currentPage = (this.currentSubcontractGoodReceiptSuggestionDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalSubcontractGoodReceiptSuggestionDetailRow + 1;
				let page = Math.ceil(totalData/this.subcontractGoodReceiptSuggestionDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.subcontractGoodReceiptSuggestionDetailPageSize = 0;
			// disable paging end
			SubcontractGoodReceiptSuggestionDetail.getList(this, filter, this.sortingBySubcontractGoodReceiptSuggestionDetail, currentPage , this.subcontractGoodReceiptSuggestionDetailPageSize).then(result => {
				this.currentSubcontractGoodReceiptSuggestionDetailPage = currentPage + 1;
				this.subcontractGoodReceiptSuggestionDetails = result.data;
				this.totalSubcontractGoodReceiptSuggestionDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getSubcontractGoodReceipts : async function(input) {
			let filter = new SubcontractGoodReceiptFilter();
			if (input != undefined) {
				filter.SubcontractGoodReceiptNumber = input;
			}
			this.isSubcontractGoodReceiptComboLoading = true;
			SubcontractGoodReceipt.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.subcontractGoodReceipts = result.data
				}
				this.isSubcontractGoodReceiptComboLoading = false;
			})
			.catch(error => {});
		},
		getSubcontractGoodReceipts : async function(input) {
			let filter = new SubcontractGoodReceiptFilter();
			if (input != undefined) {
				filter.subcontractGoodReceiptNumber = input;
			}
			this.isSubcontractGoodReceiptComboLoading = true;
			SubcontractGoodReceipt.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.subcontractGoodReceipts = result.data
				}
				this.isSubcontractGoodReceiptComboLoading = false;
			})
			.catch(error => {});
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			this.isControlCardComboLoading = true;
			ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
				this.isControlCardComboLoading = false;
			})
			.catch(error => {});
		},
		getSubcontractGoodReceiptDetails : async function(input) {
			let filter = new SubcontractGoodReceiptDetailFilter();
			if (input != undefined) {
				filter.controlCard = input;
			}
			this.isSubcontractGoodReceiptDetailComboLoading = true;
			SubcontractGoodReceiptDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.subcontractGoodReceiptDetails = result.data
				}
				this.isSubcontractGoodReceiptDetailComboLoading = false;
			})
			.catch(error => {});
		},
		getSubcontractRequestDeliverys : async function(input) {
			let filter = new SubcontractRequestDeliveryFilter();
			if (input != undefined) {
				filter.requestDeliveryNumber = input;
			}
			SubcontractRequestDelivery.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.subcontractRequestDeliverys = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedSubcontractRequestDelivery(item) {
			if(item == undefined || item == null) {
				this.model.subcontractRequestDeliveryId = null;
				this.model.subcontractRequestDelivery = null;
			} else {
				this.model.subcontractRequestDeliveryId = item.id;
				this.model.subcontractRequestDelivery = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getDocumentStatuss : async function(input) {
			let filter = new DocumentStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			DocumentStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.documentStatuss = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedDocumentStatus(item) {
			if(item == undefined || item == null) {
				this.model.documentStatusId = null;
				this.model.documentStatus = null;
			} else {
				this.model.documentStatusId = item.id;
				this.model.documentStatus = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.subcontractGoodReceiptInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					SubcontractGoodReceipt.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'subcontractgoodreceiptindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					SubcontractGoodReceipt.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'subcontractgoodreceiptindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					SubcontractGoodReceipt.updateData(this, model, id)
					.catch((error) => {
						this.getSubcontractGoodReceipt(id);
					});
				}
			});
		},
		onHidden() {
			this.getSubcontractGoodReceipts();
		},
		addRowDataSubcontractGoodReceiptDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.subcontractGoodReceiptId =  this.modelId;
					SubcontractGoodReceiptDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getSubcontractGoodReceiptDetails(true);
						this.isShowPopupSubcontractGoodReceiptDetail = false;
					})
				} else {
					model.subcontractGoodReceiptId =  this.modelId;
					SubcontractGoodReceiptDetail.createDataDetail(this, model)
					.then(result => {
						this.getSubcontractGoodReceiptDetails(true);
						this.isShowPopupSubcontractGoodReceiptDetail = false;
					})
				}
			}
		},
		async editRowDataSubcontractGoodReceiptDetail(id) {
			this.subcontractGoodReceiptDetailId = id;
			this.isShowPopupSubcontractGoodReceiptDetail = true; 
		},
		async deleteRowDataSubcontractGoodReceiptDetail(id) {
			SubcontractGoodReceiptDetail.deleteData(this, id).then(result => { this.getSubcontractGoodReceiptDetails(); });
		},
		async resetDataSubcontractGoodReceiptDetail() {
			this.subcontractGoodReceiptDetailId = "";
			this.isShowPopupSubcontractGoodReceiptDetail = true;
		},
		async addDataSubcontractGoodReceiptDetail() {
			SubcontractGoodReceiptDetail.createData(this, { subcontractGoodReceiptId: this.modelId })
			.then(result => {
				this.getSubcontractGoodReceiptDetails(true);
			})
		},
		async addFromClipboardSubcontractGoodReceiptDetail() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, subcontractGoodReceiptId: this.modelId });
				});
				SubcontractGoodReceiptDetail.addFromClipboard(this, controlCards).then(result => { this.getSubcontractGoodReceiptDetails() });
			});
		},
		async replaceFromClipboardSubcontractGoodReceiptDetail() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, subcontractGoodReceiptId: this.modelId });
				});
				SubcontractGoodReceiptDetail.replaceFromClipboard(this, controlCards).then(result => { this.getSubcontractGoodReceiptDetails() });
			});   
		},
		showPopupUploadSubcontractGoodReceiptDetail() {
			if(this.subcontractGoodReceiptDetails != null && this.subcontractGoodReceiptDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap SubcontractGoodReceiptDetail akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadSubcontractGoodReceiptDetail = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadSubcontractGoodReceiptDetail = true;
			}
		},
		uploadDataSubcontractGoodReceiptDetail(modalEvent, newDatas) {
			this.isShowPopupUploadSubcontractGoodReceiptDetail = false; 
		},
		downloadSubcontractGoodReceiptDetail(modalEvent) {
			this.isDownloadSubcontractGoodReceiptDetail = true;
			this.filterSubcontractGoodReceiptDetail.subcontractGoodReceiptId = this.modelId;
			SubcontractGoodReceiptDetail.downloadDataDetail(this, this.filterSubcontractGoodReceiptDetail).then(result => {
				this.isDownloadSubcontractGoodReceiptDetail = false;
			}).catch(error => { this.isDownloadSubcontractGoodReceiptDetail = false; })
		},
		saveInputSubcontractGoodReceiptDetail(item) {
			if (this.subcontractGoodReceipts != null && this.subcontractGoodReceipts != undefined  && this.subcontractGoodReceipts.length > 0) {
				item.subcontractGoodReceipt = this.subcontractGoodReceipts.find(q => q.id == item.subcontractGoodReceiptId);
			}
			if (this.controlCards != null && this.controlCards != undefined  && this.controlCards.length > 0) {
				item.controlCard = this.controlCards.find(q => q.id == item.controlCardId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					SubcontractGoodReceiptDetail.updateData(this, item, item.id);
				}
			});
		},
		addRowDataSubcontractGoodReceiptSuggestionDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.subcontractGoodReceiptId =  this.modelId;
					SubcontractGoodReceiptSuggestionDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getSubcontractGoodReceiptSuggestionDetails(true);
						this.isShowPopupSubcontractGoodReceiptSuggestionDetail = false;
					})
				} else {
					model.subcontractGoodReceiptId =  this.modelId;
					SubcontractGoodReceiptSuggestionDetail.createDataDetail(this, model)
					.then(result => {
						this.getSubcontractGoodReceiptSuggestionDetails(true);
						this.isShowPopupSubcontractGoodReceiptSuggestionDetail = false;
					})
				}
			}
		},
		async editRowDataSubcontractGoodReceiptSuggestionDetail(id) {
			this.subcontractGoodReceiptSuggestionDetailId = id;
			this.isShowPopupSubcontractGoodReceiptSuggestionDetail = true; 
		},
		async deleteRowDataSubcontractGoodReceiptSuggestionDetail(id) {
			SubcontractGoodReceiptSuggestionDetail.deleteData(this, id).then(result => { this.getSubcontractGoodReceiptSuggestionDetails(); });
		},
		async resetDataSubcontractGoodReceiptSuggestionDetail() {
			this.subcontractGoodReceiptSuggestionDetailId = "";
			this.isShowPopupSubcontractGoodReceiptSuggestionDetail = true;
		},
		async addDataSubcontractGoodReceiptSuggestionDetail() {
			SubcontractGoodReceiptSuggestionDetail.createData(this, { subcontractGoodReceiptId: this.modelId })
			.then(result => {
				this.getSubcontractGoodReceiptSuggestionDetails(true);
			})
		},
		async addFromClipboardSubcontractGoodReceiptSuggestionDetail() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, subcontractGoodReceiptId: this.modelId });
				});
				SubcontractGoodReceiptSuggestionDetail.addFromClipboard(this, controlCards).then(result => { this.getSubcontractGoodReceiptSuggestionDetails() });
			});
		},
		async replaceFromClipboardSubcontractGoodReceiptSuggestionDetail() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, subcontractGoodReceiptId: this.modelId });
				});
				SubcontractGoodReceiptSuggestionDetail.replaceFromClipboard(this, controlCards).then(result => { this.getSubcontractGoodReceiptSuggestionDetails() });
			});   
		},
		showPopupUploadSubcontractGoodReceiptSuggestionDetail() {
			if(this.subcontractGoodReceiptSuggestionDetails != null && this.subcontractGoodReceiptSuggestionDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap SubcontractGoodReceiptSuggestionDetail akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadSubcontractGoodReceiptSuggestionDetail = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadSubcontractGoodReceiptSuggestionDetail = true;
			}
		},
		uploadDataSubcontractGoodReceiptSuggestionDetail(modalEvent, newDatas) {
			this.isShowPopupUploadSubcontractGoodReceiptSuggestionDetail = false; 
		},
		downloadSubcontractGoodReceiptSuggestionDetail(modalEvent) {
			this.isDownloadSubcontractGoodReceiptSuggestionDetail = true;
			this.filterSubcontractGoodReceiptSuggestionDetail.subcontractGoodReceiptId = this.modelId;
			SubcontractGoodReceiptSuggestionDetail.downloadDataDetail(this, this.filterSubcontractGoodReceiptSuggestionDetail).then(result => {
				this.isDownloadSubcontractGoodReceiptSuggestionDetail = false;
			}).catch(error => { this.isDownloadSubcontractGoodReceiptSuggestionDetail = false; })
		},
		saveInputSubcontractGoodReceiptSuggestionDetail(item) {
			if (this.subcontractGoodReceiptDetails != null && this.subcontractGoodReceiptDetails != undefined  && this.subcontractGoodReceiptDetails.length > 0) {
				item.subcontractGoodReceiptDetail = this.subcontractGoodReceiptDetails.find(q => q.id == item.subcontractGoodReceiptDetailId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					SubcontractGoodReceiptSuggestionDetail.updateData(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadSubcontractGoodReceiptDetail = false; 
			this.isShowPopupSubcontractGoodReceiptDetail = false; 
			if (modalType == 'SubcontractGoodReceiptDetail') {
				this.getSubcontractGoodReceiptDetails();
			}
			this.isShowPopupUploadSubcontractGoodReceiptSuggestionDetail = false; 
			this.isShowPopupSubcontractGoodReceiptSuggestionDetail = false; 
			if (modalType == 'SubcontractGoodReceiptSuggestionDetail') {
				this.getSubcontractGoodReceiptSuggestionDetails();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				//this.isShowSubcontractGoodReceiptDetailFilter = true;
				//this.isShowSubcontractGoodReceiptSuggestionDetailFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterSubcontractGoodReceipt = new SubcontractGoodReceiptFilter();
		this.filterSubcontractGoodReceiptDetail = new SubcontractGoodReceiptDetailFilter();
		this.filterSubcontractGoodReceiptSuggestionDetail = new SubcontractGoodReceiptSuggestionDetailFilter();
		//this.getSubcontractGoodReceipts();
		//this.getControlCards();
		//this.getSubcontractGoodReceiptDetails();
		//this.getSubcontractRequestDeliverys();
		//this.getDocumentStatuss();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getSubcontractGoodReceipt(id);
			} else {
				this.modelId = id;
				this.getSubcontractGoodReceipt(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				return true;
			}
		}
	},
	watch : {
		sortBySubcontractGoodReceiptDetail : {
			handler: function() {
				this.getSubcontractGoodReceiptDetails();
			}
		},
		sortDescSubcontractGoodReceiptDetail: {
			handler: function() {
				this.getSubcontractGoodReceiptDetails();
			}
		},
		currentSubcontractGoodReceiptDetailPage: {
			handler: function() {
				this.getSubcontractGoodReceiptDetails();
			}
		},
		subcontractGoodReceiptDetailPageSize : {
			handler: function() {
				this.getSubcontractGoodReceiptDetails();
			}
		},
		filterSubcontractGoodReceiptDetail: {
			handler: function() {
				this.getSubcontractGoodReceiptDetails();
			},
			deep: true,
		},
		sortBySubcontractGoodReceiptSuggestionDetail : {
			handler: function() {
				this.getSubcontractGoodReceiptSuggestionDetails();
			}
		},
		sortDescSubcontractGoodReceiptSuggestionDetail: {
			handler: function() {
				this.getSubcontractGoodReceiptSuggestionDetails();
			}
		},
		currentSubcontractGoodReceiptSuggestionDetailPage: {
			handler: function() {
				this.getSubcontractGoodReceiptSuggestionDetails();
			}
		},
		subcontractGoodReceiptSuggestionDetailPageSize : {
			handler: function() {
				this.getSubcontractGoodReceiptSuggestionDetails();
			}
		},
		filterSubcontractGoodReceiptSuggestionDetail: {
			handler: function() {
				this.getSubcontractGoodReceiptSuggestionDetails();
			},
			deep: true,
		},
	},
}
</script>
